import React from 'react';

const CustomRadiusTick: React.FC<any> = ({ x, y, payload }) => {
    const distance = 3;
    return (
        <text
            x={x - distance}
            y={y}
            textAnchor="end"
            fontWeight={"bold"}
            fontSize={10}
            fill="#333"
        >
            {payload.value}
        </text>
    );
};
export default CustomRadiusTick;
